import { jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r("hr", { className: "uizz-layout-my-[7px] uizz-layout-w-full uizz-layout-border-0 uizz-layout-border-t uizz-layout-border-solid uizz-layout-border-t-outline-darker/[0.06] dark:uizz-layout-border-t-outline-darker/[0.10]" });
export {
  o as default
};
//# sourceMappingURL=index.js.map
